import { useCallback } from 'react';
import { Tag } from 'antd';
import { DELIVERY_STATUS_COLORS, DELIVERY_STATUS_ICONS } from '../constants';

export const useDeliveryStatusRender = () => {
  return useCallback((status: string) => {
    if (!status) return '-';
    
    const color = DELIVERY_STATUS_COLORS[status as keyof typeof DELIVERY_STATUS_COLORS] || 'default';
    const icon = DELIVERY_STATUS_ICONS[status as keyof typeof DELIVERY_STATUS_ICONS] || null;
    
    return (
      <Tag 
        color={color} 
        icon={icon}
        style={{ fontWeight: 500 }}
      >
        {status}
      </Tag>
    );
  }, []);
};
